import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AccountSettings from './pages/AccountSettings';
import NotFoundPage from './pages/NotFoundPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import SignupPage from './pages/SignupPage';
import SignupThankYou from './pages/SignupThankYou';
import LoginPage from './pages/LoginPage';
import FreeHashtagResearch from './pages/FreeHashtagResearch';
import Layout from "./components/layout";
import './App.css';


function App() {
  return (
    <Routes>
      {/* Wrap all pages in Layout */}
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="account" element={<AccountSettings />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="signup" element={<SignupPage />} />
        <Route path="signup/thank-you" element={<SignupThankYou />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="hashtag-research" element={<FreeHashtagResearch />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

export default App;
